// 接口域名
//export const domain = "http://localhost:1414/"; //=============本地PC
// export const domain = "http://localhost:9908/"; //=============本地PC
//export const domain = 'http://localhost:56963/'; //=============本地PC
// export const domain = 'http://192.168.137.1:1414/'; //=============本地手持机
// export const domain = 'http://192.168.2.8:9909/'; //=============本地手持机
//export const domain = "https://test.class.busboss.cn/"; //=============测试
// export const domain = "/api"; //=============代理
//export const domain = "/HdApi/";
export const domain = "https://class.busboss.cn/"; //=============正式
// export const domain = process.env.NODE_ENV === "development" ? 'http://localhost:9908/' : 'https://class.busboss.cn/'; //=============正式// export const domain = process.env.NODE_ENV === "development" ? 'http://localhost:9908/' : 'https://test.class.busboss.cn/'; //=============正式
// export const domain = process.env.NODE_ENV === "development" ? 'http://192.168.137.1:9909/' : 'https://class.busboss.cn/'; //=============正式
// export const domain = process.env.NODE_ENV === "development" ? 'http://192.168.137.1:1414/' : 'https://class.busboss.cn/'; //=============正式

// 导出接口api
export default {
  // 账号登录
  login: "Admin/OnLogin", // 登录
  getUserInfo: "Admin/LoadCurrentUserInfo", // 获取用户信息
  getCompInfo: "Company/Query", //获取公司信息
  onKefuLogin: "Admin/OnKeFuLogin", //客服登录
  onChangePwd: "SysUser/SysUserPwdModify", //修改密码
  getIdCardCloudDecode: "TicketAPI/IdCardCloudDecode", //获取身份证信息
  getAgentChannel: "AgentChannel/Query", // 获取渠道
  sendLoginCode: "Admin/SysUserLoginSendVerificationCodeMsg", //发送短信验证码

  //检票
  getGetCompLine: "CompanyLine/Query", //获取公司线路`
  getLineClassDay: "LineClassDay/Query", //获取实时班次
  getOrganization: "Organization/Query", // 获取机构
  getVehicleDriver: "LineClassDayVehicleDriver/Query", //查询班次车辆司机
  getStartNode: "LineClassDayStartNode/Query", //查询上车点
  getArrivalNode: "LineClassDayArrivalNode/Query", // 查询下车点
  getTicketOrderDetai: "LineClassDay/LineClassDayTicketDetailQuery", //查询班次票据
  onCheckTicket: "TicketAPI/TicketCheckCommit", //检票提交
  onCheckTicketInfo: "TicketAPI/TicketCheckQuery", //获取检票信息
  onTicketCheckUnCommit: "TicketAPI/TicketCheckUnCommit", //退检
  onConwinVehicleQuery: "LineClassDayVehicleDriver/NewConwinVehicleQuery", //车辆资质,GPS查询
  onOldConwinVehicleQuery: "LineClassDayVehicleDriver/ConwinVehicleQuery", //旧车辆资质,GPS查询
  onCompVehicleQuery: "CompanyVehicle/Query", // 公司车辆查询
  onCompDriverQuery: "CompanyDriver/Query", //公司司机查询
  onCompDriverSimplifyQuery: "CompanyDriver/CompanyDriverSimplifyQuery", //公司司机查询
  onLineClassDayVehicleDriverBatchSave:
    "LineClassDayVehicleDriver/LineClassDayVehicleDriverBatchSave", //班次车辆保存
  onLineClassDayVehicleDriverSave: "LineClassDayVehicleDriver/Edit", //班次车辆保存
  onLineClassDayVehicleDriverDel: "LineClassDayVehicleDriver/Delete", //班次车辆删除
  onLineClassDayVehicleDriverCancelSign: "LineClassDayVehicleDriver/Edit", //车辆取消签到
  onContractReport: "LineClassDay/NewContractReport", //发车报备
  onLineClassDayContractQuery: "LineClassDayContract/Query", //班次合同查询
  onLineClassDayStartNodeDataUploadQuery:
    "LineClassDayStartNodeDataUpload/Query", //电子路单查询
  onLineClassDayNodeStatementMsgSend:
    "/LineClassDayStartNode/LineClassDayNodeStatementMsgSend", // 路单报备
  onLineClassDayContractDel: "LineClassDayContract/Delete", //班次合同删除 取消发车
  onCerTypeQuery: "CoreSysCode/Query", //证件类型查询
  onUpdateRealName: "TicketOrderDetail/TicketInfoUpdate", //更新票乘客信息
  onTicketOrderPayDo: "TicketOrder/WX_TicketOrderPayDo", //订票支付
  onGetVehicleDriverSeatCount:
    "LineClassDayVehicleDriver/LineClassDayVehicleDriverSeatCountQuery", //座位总数及免票儿童查询
  tokenRefresh: "Admin/TokenRefresh", //刷新Token
  getLineClassDayDepartureRecord: "LineClassDayDepartureRecord/Query", //获取班次发车记录
  onLineClassDayDepartureRecordSave: "LineClassDayDepartureRecord/Create", //保存班次发车记录
  onLineClassDayDepartureRecordDel: "LineClassDayDepartureRecord/Delete", //删除发车记录
  getMapData: "LineClassDay/WX_TicketOrderDetailMapDataQuery", //获取班次地图数据
  onLineClassDayContractReSend:
    "LineClassDayContract/LineClassDayContractMsgSend", //重新发送合同给司机
  geiLineClassDayPrice: "LineClassDayPrice/Query", //获取班次票价
  onLineStartNodeNodeGroupNameQuery: "LineStartNode/LineStartNodeNodeGroupNameQuery",//获取上车站点分组
  onLineArrivalNodeNodeGroupNameQuery: "LineArrivalNode/LineArrivalNodeNodeGroupNameQuery",//获取下车站点分组
  onBookTicketCheckUnCommitRestored:
    "TicketAPI/BookTicketCheckUnCommitRestored", //订票退检还原
  onTicketBookCancel: "TicketAPI/TicketBookCancel", //订票取消订单
  onTicketCancel: "TicketAPI/TicketOrderCancel", //订票取消订单
  IDCardOcr: "TicketAPI/IDCardOcr", //OCR身份证识别
  onNodeReviseQuery: "NodeRevise/Query", //站点修正记录查询
  onNodeReviseSave: "NodeRevise/Create", //站点信息修正
  onNodeQuery: "Node/Query", //站点基础信息查询
  onLineClassDaySignInErrorRecordSave: "LineClassDaySignInErrorRecord/Create", //班次签到失败记录保存
  onTicketCheckDetailPrintQuery:
    "TicketOrderDetail/TicketCheckDetailPrintQuery", //打印结算清单
  onTicketCustDetailQuery: "TicketOrderDetail/TicketCustDetailQuery", //获取车票手机号码
  onUploadAttachment: "Attachment/Create", //附件上传
  onLineClassDayAttachmentQuery: "Attachment/Query", //附件查询
  onDeleteAttachment: "Attachment/Delete", //附件删除
  onDriverIndustryCertNoSearch: "Driver/DriverIndustryCertNoSearch", //司机从业资格证查询
  onLineClassDayVehicleDriverErrorRecordCreate:
    "LineClassDayVehicleDriverErrorRecord/Create",
  getVehicleCert: "VehicleCert/Query", // 获取车辆资料
  onNodeSignInCreat: "LineClassDayStartNodeSignIn/Create", //站点签到
  onNodeSignInDel: "LineClassDayStartNodeSignIn/Delete", //站点取消签到
  TicketOrderDetailCallHistory: "TicketOrderDetailCallHistory/Create", // 手机号码拨打次数
  SecurityLine: "CompanyLine/Query", // 安检线路
  CompanyVehicleSimplifyQuery: "CompanyVehicle/CompanyVehicleSimplifyQuery", // 车辆
  GuestNodeManageCheckCreate: "GuestNodeManageCheck/Create", // 创建安检单
  GuestNodeCustomerBagCheckCreate: "GuestNodeCustomerBagCheck/Create", // 创建行李异常登记
  SysUserSysUserConfigSave: "SysUser/SysUserConfigSave", // 用户配置保存

  //售票
  getLineClassStartNode: "LineStartNode/Query", // 获取线路上车点
  getLineClassArrivalNode: "LineArrivalNode/Query", // 获取线路下车点
  getStartNodeQuery: "TicketAPI/StartNodeQuery", // 获取上车点数据
  getArrivalNodeQuery: "TicketAPI/ArrivalNodeQuery", // 获取下车点数据
  getLineClassDaySaleQuery: "TicketAPI/LineClassDaySaleQuery", // 获取该班线的票
  getLineClassSeatMapQuery: "LineClass/LineClassSeatMapQuery", // 获取班次座位
  createTicketOrder: "/TicketAPI/TicketOrderCreate", // 售票订单创建
  submitTicketOrder: "/TicketAPI/TicketOrderCommit", // 提交订单 -- 现金支付时候用
  lastSaleDetails: "/TicketDetailPrint/TicketDetailPrintLastQuery", // 获取上一次售票明细
  BackTicket: "/TicketAPI/TicketBackRateQuery", // 退票查询
  BackTicketCommit: "/TicketAPI/TicketBackCommit", // 退票提交
  TicketDetailBackPrintQuery: "/TicketAPI/TicketDetailBackPrintQuery", // 退票打印凭证
  TicketSalePaymentQuery: "/TicketSalePayment/Query", // 售票缴款查询
  TicketSalePaymentSubmit: "TicketSalePayment/TicketSalePaymentSubmit", // 提交缴款
  TicketSalePaymentPrintQuery: "TicketSalePayment/TicketSalePaymentPrintQuery", // 打印缴款凭证
  CompanyOrderSourceQuery: "CompanyOrderSource/Query", // 查询订单来源
  TicketOrderQuery: "TicketOrder/Query", // 查询订单
  MonthTicketUseOnClassQuery:
    "MonthTicketOrderDetail/MonthTicketUseOnClassQuery", //查询月票是否能使用
  TicketDetailChangeLineClass: "/TicketAPI/TicketDetailChangeLineClass", //改乘
  WXQYTicketCreate: "/TicketAPI/WXQYTicketCreate", //员工班线下单
  // 班线管理
  getTicketOrderDetail: "TicketOrderDetail/Query", // 获取售票明细
  getTicketCheckDetail: "TicketCheckDetail/Query", // 获取检票明细
  editLineClassDayStartNode: "LineClassDayStartNode/Edit", // 修改上车点
  editLineClassDayArrivalNode: "LineClassDayArrivalNode/Edit", // 修改下车点
  editLineClassDayStatus: "LineClassDay/LineClassDayStatusEdit", // 修改班次状态
  LineClassDayCopy: "LineClassDay/LineClassDayCopy", // 复制班次
  editLineClassDay: "LineClassDay/Edit", // 修改班次内容
  lineClassSeatMapModify: "LineClass/LineClassSeatMapModify", //修改班次座位数
  lineClassDayPriceBatchEditSave:
    "LineClassDayPrice/LineClassDayPriceBatchEditSave", //班次票价修改
  LineClassDayHandheldSave: "LineClassDay/HandheldSave", //修改联系电话
  LineClassDayHandheldInfoQuery: "LineClassDay/HandheldInfoQuery", //修改联系电话信息查询
  //车辆管理
  onDeleteVehicle: "CompanyVehicle/Delete", //删除车辆
  onDeleteDriver: "CompanyDriver/Delete", //删除司机
  onGetCoreColor: "CoreSysCode/Query", //获取系统车牌颜色
  onSaveVehicle: "CompanyVehicle/Edit", //车辆信息保存
  onSaveDriver: "CompanyDriver/Edit", //公司司机保存
  onGetDirver: "Driver/Query", //获取系统司机
  onGetDriverIndustryCertNo: "Driver/DriverIndustryCertNoSearch", //司机从业资格证查询
  API_getVehicleInfo:
    "/LineClassDayVehicleDriver/VehicleCompanyPreCheckDataBaseLinkQuery", //车辆资质查询接口
  getDriverSimplifyQuery: "/Driver/DriverSimplifyQuery", // 司机/跟车员
  getCompanyDriverSimplifyQuery: "/CompanyDriver/CompanyDriverSimplifyQuery", // 司机/跟车员

  //新签到相关
  LicensePlateOCR: "LineClassDay/LicensePlateOCR", //车牌号码OCR
  NewLicensePlateOCR: "LineClassDay/NewLicensePlateOCR", //新车牌号码OCR
  lineClassDayDepartureRecordNewSignInSave:
    "LineClassDayDepartureRecord/NewSignInSave", //保存班次发车记录
  getSignBoardNumber: "LineClassDayVehicleDriver/SignBoardNumberInfoQuery", //标志牌号查询

  //班次功能
  TicketOrderDetailSendMsgNotice:
    "/TicketOrderDetail/TicketOrderDetailSendMsgNotice", //消息发送

  //系统功能
  RedisCacheQuery: "/RedisCache/Query", //缓存查询
  RedisCacheDelete: "/RedisCache/Delete", //缓存删除

  // 站点检票
  getCompanyStartNode: "/NodeCheckManagement/CompanyStartNodeQuery", // 获取公司始发站点
  getNodeLineClassDay: "/NodeCheckManagement/NodeLineClassDayQuery", // 获取站点途径班次

  // 健康码信息保存
  HealthInfoSave: "/TicketOrderDetailHealthInfo/Create",

  DriverTicketCheckDataQuery: "/Driver/TicketCheckDataQuery",
  HandheldStatAttendanceRatioQuery: "/HandheldStat/AttendanceRatioQuery",
  HandheldStatTicketOrderDetailQuery: "/HandheldStat/TicketOrderDetailQuery",

  // 修改座位状态
  LineClassSeatStatusChange: "/LineClass/LineClassSeatStatusChange",

  // 线路发车
  LineDepartureRecordCreate: "/LineDepartureRecord/Create",
  // 线路发车查询
  getLineDepartureRecord: "/LineDepartureRecord/Query",
  // 线路车票查询
  getLineNodeTicket: "/LineDepartureRecord/LineNodeTicketQuery",

  // oys 2025-02-08 09:30
  // 省份查询
  getProvince: "/Province/Query",
  // 城市查询
  getCity: "/City/Query",
  // 系统字典表查询
  getCoreSysDictionaryCode: "/CoreSysDictionaryCode/Query",
  // 拼车订单查询
  getCarPoolUserDetail: "/CarPoolUserDetail/Query",

  // oys 2025-02-11 12:23
  // 上门接接驳订单查询
  getTicketConnectOrder: "/TicketConnectOrder/Query",

  //站点车辆到站状态
  getNodeVehicleArrivalStatus: '/NodeVehicleArrivalStatus/Query',
  saveNodeVehicleArrivalStatus: '/NodeVehicleArrivalStatus/Edit'
};
